import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Login from './components/Login.vue'
import RegistroAnfitrion from './views/RegistroAnfitrion.vue'
import Home from './views/Home.vue'
import Dashboard from './views/Dashboard.vue'
import RegistroAlojamiento from './views/RegistroAlojamiento.vue'
import Success from './views/Success.vue'
import Update from './views/Update.vue'
import EditarPerfil from './views/EditarPerfil.vue'
import CambiarPassword from './views/CambiarPassword.vue'
import EditarAlojamiento from './views/EditarAlojamiento.vue'
import DetalleAlojamiento from './views/DetalleAlojamiento.vue'
import Test from './views/Test.vue'
import TestEnd from './views/TestEnd.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'registro-anfitrion',
      component: RegistroAnfitrion
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/registro-alojamiento',
      name: 'Registro Alojamiento',
      component: RegistroAlojamiento,
      meta: { 
        requiresAuth: true 
      }
    },
    {
      path: '/editar-alojamiento/:idalojamiento',
      name: 'Editar Alojamiento',
      component: EditarAlojamiento,
      meta: { 
        requiresAuth: true 
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: { 
        requiresAuth: true 
      }
    },
    {
      path: '/exito',
      name: 'Success',
      component: Success,
      meta: { 
        requiresAuth: true 
      }
    },
    {
      path: '/actualizado_con_exito',
      name: 'Update',
      component: Update,
      meta: { 
        requiresAuth: true 
      }
    },
    {
      path: '/editar-perfil',
      name: 'Editar Perfil',
      component: EditarPerfil,
      meta: { 
        requiresAuth: true 
      }
    }, 
    {
      path: '/cambiar-password',
      name: 'Cambiar Password',
      component: CambiarPassword,
      meta: { 
        requiresAuth: true 
      }
    }, 
    {
      path: '/test',
      name: 'test',
      component: Test
    }, 
    {
      path: '/test/end',
      name: 'TestEnd',
      component: TestEnd
    },     
    {
      path: '/alojamiento/:idalojamiento/:nombrealojamiento',
      name: 'detalle-alojamiento',
      component: DetalleAlojamiento
    }, 
    {
      path: '/alojamiento/:idalojamiento',
      name: 'detalle-alojamiento',
      component: DetalleAlojamiento
    },                         
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login') 
  } else {
    next() 
  }
  

})


export default router